import { c as _c } from "react/compiler-runtime";
import { ChartData, Chart as ChartJS, ScatterDataPoint } from 'chart.js';
import ChartBox from 'modules/main/components/chart-box-section/chart-box';
import ChartsSkeleton from 'modules/main/components/chart-box-section/charts-skeleton';
import { options } from 'modules/main/components/chart-box-section/constants';
import { ChartBoxSectionProps } from 'modules/main/components/chart-box-section/types';
import { useMain } from 'modules/main/hooks/use-main';
import { getChartconfig } from 'modules/management/email-delivery-statistics/util/get-chart-config';
import { useRouter } from 'next/router';
import { MouseEvent, useEffect, useRef, useState } from 'react';
import { Chart, getElementAtEvent } from 'react-chartjs-2';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { toShortDate } from 'shared/utils/date-time-format';
export interface LeadsChartBoxProps extends ChartBoxSectionProps {}
export const LeadsChartBox = t0 => {
  const $ = _c(17);
  const {
    filter
  } = t0;
  const chartRef = useRef(null);
  const {
    t
  } = useLocoTranslation();
  const {
    leads
  } = useMain(filter);
  const {
    user,
    intlLocale
  } = useUser();
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      labels: [],
      datasets: []
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [leadsData, setLeadsData] = useState(t1);
  let t2;
  if ($[1] !== leads?.values || $[2] !== router || $[3] !== user) {
    t2 = event => {
      const {
        current: chart
      } = chartRef;
      if (!chart) {
        return;
      }
      const element = getElementAtEvent(chart, event);
      if (!element.length) {
        return;
      }
      const {
        index
      } = element[0];
      if (user) {
        router.push(`/contacts?filter=%5B%7B"searchValue"%3A"${leads?.values[index].date}T00%3A00%3A00"%2C"compareOperation"%3A"EQUALS"%2C"searchField"%3A"created_at"%7D%5D`);
      }
    };
    $[1] = leads?.values;
    $[2] = router;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onClick = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      if (chartRef.current) {
        if (chartRef.current.getElementsAtEventForMode(e as unknown as Event, "nearest", {
          intersect: true
        }, true).length === 0) {
          chartRef.current.canvas.style.cursor = "default";
        } else {
          chartRef.current.canvas.style.cursor = "pointer";
        }
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onPointerMove = t3;
  let t4;
  let t5;
  if ($[6] !== intlLocale || $[7] !== leads) {
    t4 = () => {
      if (leads) {
        setLeadsData(getChartconfig({
          labels: leads.values.map(value => toShortDate(value.date, intlLocale)),
          data: leads.values.map(_temp)
        }));
      }
    };
    t5 = [intlLocale, leads];
    $[6] = intlLocale;
    $[7] = leads;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== filter || $[11] !== intlLocale || $[12] !== leads || $[13] !== leadsData || $[14] !== onClick || $[15] !== t) {
    t6 = leads ? <ChartBox title={t("dashboard.main.new_leads").toUpperCase()} total={new Intl.NumberFormat(intlLocale).format(leads.total)} diffPercents={leads.diffPercents} countDays={leads.countDays} dateSince={filter.dateSince} chart={<Chart ref={chartRef} type="line" onClick={onClick} onPointerMove={onPointerMove} height={200} data={leadsData} options={options} />} /> : <ChartsSkeleton />;
    $[10] = filter;
    $[11] = intlLocale;
    $[12] = leads;
    $[13] = leadsData;
    $[14] = onClick;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(el) {
  return el.value;
}